export const validateNIRC = (input, dateOfBirth) => {

    const match = input.match(/^(?<prefix>[STFGM])(?<digits>\d{7})([A-Z])$/);
    if(match) {
        return true;
    } else {
        return false;
    }

    //Disabled: User complaint about some NRIC may not fully follow the checksum.
    /*const match = input.match(/^(?<prefix>[STFGM])(?<digits>\d{7})(?<checksum>[A-Z])$/);
    if (!match) {
        return false;
    }

    // @ts-ignore
    const { prefix, digits, checksum } = match.groups;

    // validate only DoB of local singaporean
    if ((prefix === 'S' || prefix === 'T') && dateOfBirth) {
        if (new Date(dateOfBirth).getFullYear() < 2000 && prefix !== 'S') {
            return false;
        }

        if (new Date(dateOfBirth).getFullYear() > 2000 && prefix !== 'T') {
            return false;
        }
    }

    let offset = 0;

    if (prefix === 'T' || prefix === 'G' ) {
        offset = 4;
    } else if (prefix === 'M') {
        offset = 3;
    }

    const weights = [2, 7, 6, 5, 4, 3, 2];

    const sum = (digits)
        .split('')
        .reduce((accumulation, char, index) => accumulation + parseInt(char, 10) * weights[index], offset);

    let checksums = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A']

    if (prefix === 'F' || prefix === 'G') {
        checksums = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K'];
    } else if (prefix === 'M') {
        checksums = ["K", "L", "J", "N", "P", "Q", "R", "T", "U", "W", "X"];
    }
     

    let index = sum % 11;

    if (prefix === 'M') {
        index = 10 - index;
    }

    return checksum === checksums[index];

    */
};
